/* eslint-disable */
import React, { Component } from 'react';
import { Button, Grid, Header, Segment } from 'semantic-ui-react';

class InsuranceProds extends Component {
  render() {
    return (
      <div>
      <Segment style={{ padding: '8em 0em', backgroundColor:'#5AD0D2' }} vertical>
        <Grid container stackable>
          <Grid.Row>
            <Grid.Column width={16}>
               <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> Insurance products. </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <Button circular icon='stethoscope' label='workers compensation' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='handshake outline' label='directors & officers (D&O)' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='cloud' label='tech errors and omissions' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='briefcase' label='employment practices liability' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              <Button circular icon='car' label='business auto'size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='coffee' label='bussiness owner policy' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='shield' label='general liability' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='life ring' label='professional liability' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              <Button circular icon='umbrella' label='umbrella' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='key' label='product liability'size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='building' label='property' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

            <Grid.Column width={4}>
              <Button circular icon='spy' label='cyber' size='big' style={{ fontSize: '1em', fontFamily: 'Montserrat' }}/>
            </Grid.Column>

          </Grid.Row>
        </Grid>
      </Segment>
      </div>
    );
  }
};

export default InsuranceProds;



// WEBPACK FOOTER //
// ./src/js/Home/InsuranceProds.js